import React from 'react';
import { ImageTag } from 'src/services';
import { AvailableIcons, EllipsisWithTooltip } from 'src/components-dummy';
import { TagIconStyled, TagStyled } from './TagsSection.styles';
import { AiTagIconStyled } from 'src/components-bl/Galleries/CustomInspirations/components/ProductTags/components/ProductTagPopUp/ProductTagPopUp.styles';

interface TagProps {
  tag: ImageTag;
  removeTagById: (id: string) => void;
}

export const Tag = ({ tag, removeTagById }: TagProps): JSX.Element => {
  const onRemove = () => {
    removeTagById(tag.id);
  };

  return (
    <TagStyled>
      {tag.isAIDetected && <AiTagIconStyled name={AvailableIcons.Stars} isApplied />}

      <EllipsisWithTooltip tooltipText={tag.title}>{tag.title}</EllipsisWithTooltip>

      <TagIconStyled name={AvailableIcons.CloseLight} onClick={onRemove} />
    </TagStyled>
  );
};
